import { render, staticRenderFns } from "./AdminLoginPage.vue?vue&type=template&id=08dc637c&scoped=true&"
import script from "./AdminLoginPage.vue?vue&type=script&lang=js&"
export * from "./AdminLoginPage.vue?vue&type=script&lang=js&"
import style0 from "./AdminLoginPage.vue?vue&type=style&index=0&id=08dc637c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dc637c",
  null
  
)

export default component.exports